import { render, staticRenderFns } from "./setDrawer.vue?vue&type=template&id=6e10ad2c&scoped=true"
import script from "./setDrawer.vue?vue&type=script&lang=js"
export * from "./setDrawer.vue?vue&type=script&lang=js"
import style0 from "./setDrawer.vue?vue&type=style&index=0&id=6e10ad2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10ad2c",
  null
  
)

export default component.exports